module.exports = __webpack_public_path__ + "static/media/china-cover.b6576a46.jpg";